import {useStore} from "../../store/store";
import React, {useEffect, useState} from "react";
import {  Navigate } from "react-router-dom";


export default function Logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('items');
    localStorage.removeItem('itemVariants');
    localStorage.removeItem('username');
    const [globalState, dispatch] = useStore();
    const [showModal, setShowModal] = useState();

    dispatch('SET_AUTHTOKEN', null);
    dispatch('SET_AUTHTOKEN_ERZEUGER', null);
    return (<Navigate replace to="/home" />);

}